import { Button, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect,useState } from "react";
import {Form,Spinner, Modal} from 'react-bootstrap';
import axios from "axios";
import Cookies from "js-cookie";
import useAuth from "../../../hooks/useAuth";
import { RADIUS_API } from "../../Radius";
import Graphe from "../../../components/Graphes/Graphes";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);



function DashboardHome(){
    const[ civilite, setCivilite] = useState({
      'M':'0',
      'F':0
    })
    
    const [data, setData] = useState([]);
    const [ecole, setEcole] = useState('');
    const [dataSize, setDataSize] = useState(0);
    const [totalRadius, setTotalRadius] = useState(0);
    const { auth } = useAuth();
    const token = auth?.accessToken || Cookies.get('accessToken');
    const [statEcole, setStatEcole] = useState({
      'student': '0',
      'teacher': '0',
      'ES2A': '0',
      'ESU2A': '0',
      'ESMGE': '0'
    })
    const [centre, setCentre] = useState({
      'Diamniadio': '0',
      'Diourbel': '0',
      'Kolda': '0',
      'Ziguinchor': '0',
      'Fatick': '0',
      'Kédougou': '0',
      'Louga': '0',
      'Matam': '0',
      'Tambacounda': '0',
      'Podor': '0',
      'Thiès':'0',
      'Kaolack':'0'
    })
    const handleChange = (event) => {
      const { name, value } = event.target;
      setEcole(value)
    };
    const [sizecentre, setsizecentre] = useState('')
    const url = `https://depot.uam.sn/api/v1/backup/recrutement?type_poste=${ecole}`;
    // const [stats, setStat] = useState([])
    // const [statsV, setStatV] = useState([])
    useEffect(() => {
      // Nombre de candidatures RADiUS (route protégée : token obligatoire)
      axios.get(`${RADIUS_API}/`, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => setTotalRadius(response.data?.total ?? response.data?.candidats?.length ?? 0))
        .catch((error) => console.error('Erreur récupération du nombre de candidatures RADiUS', error));
    }, [token])
    return (

        <div className="container mt-3 mb-3">
            <p className="body">DashBoard Home</p>
            <div className="p-3 mt-2 " style={{padding : '12px', width : '20%', border : '2px solid #fff', boxShadow : '0px 0px 10px rgba(0, 0, 0, 0.2)'}}>
                    <div className="">
                    <h6 style={{color : '#000', marginBottom : '20px', opacity : '0.6'}} className="">Dossiers RADiUS <br /> </h6>
                    <span className=" text-center fw-bold h2 mb-4 p-3" style={{marginBottom : '20px'}} >{totalRadius}</span> <br />
                    <span className=" text-center mb-4 p-3" style={{marginBottom : '20px'}} >candidature(s)</span>
                    </div>
            </div>
            {/* <Form.Group>
              <Form.Label className='fw-medium'>Choisir un centre<span style={{color:'red'}}>*</span></Form.Label>
              <Form.Select name='region' required value={ecole} onChange={handleChange}>
                <option value="">Choisir un centre</option>
                <option value="Diamniadio (UAM)">Diamniadio (UAM)</option>
                <option value="Diourbel">Diourbel</option>
                <option value="Kaolack">Kaolack</option>
                <option value="Kédougou">Kédougou</option>
                <option value="Matam">Matam</option>
                <option value="Saint-Louis">Saint-Louis</option>
                <option value="Tambacounda">Tambacounda</option>
                <option value="Thiès">Thiès</option>
                <option value="Ziguinchor">Ziguinchor</option>
                <option value="Podor">Podor</option>
                <option value="Louga">Louga</option>
                <option value="Kolda">Kolda</option>
              </Form.Select>
           </Form.Group> */}
           {/* {sizecentre}
           <br />
            <a href={url} className="btn btn-primary">
            <div>  
                Extraire {ecole}
            </div>
            </a>

            
            
             <div className="p-3 mt-2 bg-info bg-opacity-10 border border-success border-start-0 rounded-end">
                    <h6>Candidats postulés pour ESTI : <span className="">{statEcole['ESTI'] ? statEcole['ESTI'] : 0}</span></h6>
            </div>
           <div className="p-3 mt-2 bg-info bg-opacity-10 border border-success border-start-0 rounded-end">
                    <h6>Candidats postulés pour HEEG : <span className="">{statEcole['HEEG'] ? statEcole['HEEG'] : 0}</span> </h6>
            </div>
            <div className="p-3 mt-2 bg-info bg-opacity-10 border border-success border-start-0 rounded-end">
                    <h6>Candidats postulés pour ES2A : <span className="">{statEcole['ES2A'] ? statEcole['ES2A'] : 0}</span> </h6>
            </div> */}
            <Link to="/dashboard/radius" className="text-decoration-none">
              <div className="p-3 mt-2 bg-success bg-opacity-10 border border-success border-start-0 rounded-end">
                      <h6 className="m-0 text-dark">Appel à candidature RADiUS : consulter les {totalRadius} dossier(s) déposé(s) &rarr;</h6>
              </div>
            </Link>
                {/* <div id="diagrammes" className="d-flex flex-row flex-wrap">
                  Statistques par centre <br />
                    <div>
                        <p>Choix de l'école</p>
                        <Graphe data={[statEcole.ESTI,statEcole.HEEG ,statEcole.ES2A ,statEcole.ESU2A , statEcole.ESMGE]} labels={['ESTI', 'HEEG','ES2A',"ESU2A","ESMGE"]} />
                    </div>
                    <div>
                        <p>Civilité</p>
                        <Graphe data={[civilite.F, civilite.M]} labels={['Feminin', 'Masculin']} />
                    </div>
                </div> */}
        </div>
    )
}

export default DashboardHome;